import React from "react";
import { useIntl } from "react-intl";
import { usePinnedObjectLoading } from "./hooks/usePinnedObjectLoading";
import styles from "./PinnedObjectLoadingIndicator.scss";

export function PinnedObjectLoadingIndicator() {
  const intl = useIntl();
  const progress = usePinnedObjectLoading();

  if (!progress.total || progress.done) return null;

  return (
    <div className={styles.indicator}>
      {intl.formatMessage(
        {
          id: "pinned-object-loading.progress",
          defaultMessage: "Loading objects {percent}% ({loadedCount}/{total})"
        },
        progress
      )}
    </div>
  );
}
